module.exports = __webpack_public_path__ + "assets/img/aiwriter-bus2.159125f7.png";